import React, { useState, useMemo, useEffect } from 'react';
import { Table } from '../../components';
import './mleMakerChecker.scss';
import { toast } from 'react-toastify';
import { ERROR_MESSAGES } from '../../utils/constants/toastMessages';
import { API_VIEW_KYC_DOCUMENT } from '../../utils/API/apiUrls';
import { POST } from '../../utils/fetchWrappers';
import { apiStatusCodes } from '../../utils/API/apiStatusCodes';
import ImageViewModal from '../Onboarding/Mle/BusinessTab/ImageViewModal';
import { setDataCheckerRemark } from './mleMakerChecker.utils';

const OwnershipDetailsView = ({ data, section, additionalData, auth, handleCheckerRemarksData, isViewMode, editedFields }) => {
  
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const checkerRemarksData = additionalData || [];
  const flattenObject = (obj = {}, parentKey = '') =>
    Object.entries(obj).reduce((acc, [key, value]) => {
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        Object.assign(acc, flattenObject(value, newKey));
      } else {
        acc[newKey] = value;
      }
      return acc;
    }, {});

  const flattenedData = useMemo(() => flattenObject(data), [data]);

  const handleViewClick = async (docUrl) => {
    const request = { s3Path: docUrl };
    try {
      
      const response = await POST(API_VIEW_KYC_DOCUMENT, request, {}, true);
      const { data } = response;
      if (data && data.statusCode === apiStatusCodes.SUCCESS) {
        setSelectedDocument(data.s3Url);
      } else {
        toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
      }
    } catch (error) {
      toast.error(ERROR_MESSAGES.FALLBACK_ERROR);
    }
  };

  const fetchData = setDataCheckerRemark(checkerRemarksData, flattenedData, section, handleViewClick, isViewMode, editedFields);

  const [ownershipDetailData, setOwnershipDetailData] = useState(fetchData);

  useEffect(() => {
    setOwnershipDetailData(fetchData);
    
    handleCheckerRemarksData(section, fetchData);
  },[additionalData]);

  const updateCheckerRemarks = (updatedData) => {
    setOwnershipDetailData(updatedData);
    handleCheckerRemarksData(section, updatedData); // Propagate changes to parent
  };

  const handleAction = (key, actionType) => {
    
    
    const updatedData = ownershipDetailData.map((item) =>
      item.clubKey === key ? { ...item, status: actionType.toUpperCase() } : item
    );
    
    updateCheckerRemarks(updatedData);
  };

  const handleRemarks = (key, value) => {
    const updatedData = ownershipDetailData.map((item) =>
      item.key === key ? { ...item, remarks: value } : item
    );
    updateCheckerRemarks(updatedData);
  };

  const fieldsWithViewLink = ['BANK_PROOF', 'URL', 'ADDRESSPROOFURLS'];

  const columns = useMemo(
    () => [
      { header: 'Label', accessor: 'label' },
      { header: 'Value', accessor: 'clientValue' },
      { header: 'Approve', accessor: 'action1' },
      { header: 'Reject', accessor: 'action2' },
      { header: 'Remarks', accessor: 'action3' },
    ],
    []
  );

  

  return (
    <div className="checker-wrapper">
      <Table
        columns={columns}
        data={ownershipDetailData}
        fetchData={() => {}}
        loading={loading}
        userActions={(data, cell) => {
          const field = data.original?.clubKey;
          const uniqueName = `${section}-${data.index}`; // Ensure unique name for radio buttons

          if (cell.column.header === 'Approve') {
            return (
              <input
                checked={data?.original?.status === 'APPROVE'}
                type="radio"
                className="radiogreen"
                name={uniqueName}
                disabled={isViewMode}
                onChange={() => handleAction(field, 'Approve')}
              />
            );
          }
          if (cell.column.header === 'Reject') {
            return (
              <input
                checked={data?.original?.status === 'REJECT'}
                type="radio"
                className="radiored"
                name={uniqueName}
                disabled={isViewMode}
                onChange={() => handleAction(field, 'Reject')}
              />
            );
          }
          if (cell.column.header === 'Remarks') {
            return (
              <input
                value={data?.original?.remarks || ''}
                type="text"
                name={`remarks-${uniqueName}`}
                className="eachRemarks"
                disabled={isViewMode}
                onChange={(e) => handleRemarks(data.original?.key, e.target.value)}
              />
            );
          }
          return null;
        }}
      />
      {selectedDocument && (
        <ImageViewModal
          selectedDocument={selectedDocument}
          setSelectedDocument={setSelectedDocument}
        />
      )}
    </div>
  );
};

export default OwnershipDetailsView;
